import PropTypes from 'prop-types'
import React from 'react'

import ButtonCircle from 'components/ButtonCircle'

import './ButtonRemove.scss'

/**
 * ButtonRemove — circle button with cross icon inside and description around
 *
 * @param {object} props - properties of component
 * @returns {node} ButtonRemove
 */
const ButtonRemove = props => {
  const { onClick, title, isDisabled } = props

  return (
    <div className="button-remove">
      <ButtonCircle
        isDisabled={isDisabled}
        bgClassName="bg--transp bg--border-gray"
        textClassName="text--white"
        icon="btn_cross"
        iconColor="black"
        as="button"
        wrapperProps={{
          onClick,
        }}
      />
      <div className="button-remove__title-box ml-15">
        <span
          className="button-remove__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </div>
  )
}

ButtonRemove.propTypes = {
  /** Title of button */
  title: PropTypes.string.isRequired,

  /** Button click callback */
  onClick: PropTypes.func.isRequired,

  /** Enable or disable button */
  isDisabled: PropTypes.bool,
}

ButtonRemove.defaultProps = {}

export default ButtonRemove
